<template>
  <!-- 費率設定這版不會上，會改頁面流程。先開給QA方便設定費率資料，上線前移除費率設定tab入口 -->
  <!-- 不過後續費率設定還是會使用此component -->
  <div class="time-setting" :class="{'disabled': disabled}" @mouseup="handleCellMouseUp">
    <div class="action-top">
      <div>
        <ul>
          <li>{{ $t('EvCharging.HightTimeUseHightPrice') }}</li>
          <li>{{ $t('EvCharging.OtherTimeUseLowPrice') }}</li>
        </ul>
      </div>
      <div class="description">
        {{ $t('EvCharging.ChooseTimeHint') }}
      </div>
    </div>
    <div class="head">
      <div class="item-title column-1 table-item-title">
        星期/時刻
      </div>
      <div class="hour column-2">
        <div v-for="hour in 25" :key="hour" class="hour-display">
          {{ (hour - 1).toString().padStart(2, '0') }}
        </div>
      </div>
      <div class="blank-block column-3"></div>
    </div>
    <div class="content" @mousedown="handleCellMouseDown($event)" @mousemove="handleCellMouseMove($event)">
      <div v-for="day in 7" :key="day" class="day">
        <div class="time-title column-1 box">
          星期{{ DAY[day-1] }}
        </div>
        <div class="time-box-block column-2">
          <div
            v-for="hour in 24"
            :key="`time-box-${hour}`"
            class="time-box box" :class="{
              'active': (mouseDown && day-1 === activeData.day && activeHour.length && hour-1 <= activeHour[1] && hour-1 >= activeHour[0]),
              'selected': selectedTime[day-1][hour-1]
            }"
          >
          </div>
        </div>
        <div class="btn-allDay column-3 box">
          <el-button type="primary" size="mini" :disabled="disabled" @click="handleClickAllDay(day-1)">
            整天
          </el-button>
        </div>
      </div>
    </div>
    <div class="action">
      <el-button type="danger" round @click="handleClickClearAll">
        {{ $t('General.ClearAll') }}
      </el-button>
      <el-button round @click="close">
        {{ $t('General.Cancel') }}
      </el-button>
      <el-button type="primary" round @click="handleClickSave">
        {{ $t('General.Store') }}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    timeData: {
      type: Object,
      default: () => ({})
      // 格式為
      // {
      //    Sunday: [[0, 12], [15, 18]], (= 0點~12點、15點~18點)
      //    Monday: [],
      //    ...
      //  }
    }
  },

  data () {
    return {
      DAY: ['一', '二', '三', '四', '五', '六', '日'],
      BOX_SIZE: {
        HEIGHT: 40,
        WIDTH: 40
      },
      WEEKDAY: [
        {
          dayIndex: 0,
          display: '一',
          name: 'Monday'
        },
        {
          dayIndex: 1,
          display: '二',
          name: 'Tuesday'
        },
        {
          dayIndex: 2,
          display: '三',
          name: 'Wednesday'
        },
        {
          dayIndex: 3,
          display: '四',
          name: 'Thursday'
        },
        {
          dayIndex: 4,
          display: '五',
          name: 'Friday'
        },
        {
          dayIndex: 5,
          display: '六',
          name: 'Saturday'
        },
        {
          dayIndex: 6,
          display: '日',
          name: 'Sunday'
        }
      ],
      ALL_DAY: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      CLEAR_ALL_DAY: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      selectedTime: [
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      ],
      mouseDown: false,
      activeData: {
        day: null,
        startHour: null,
        endHour: null
      }
    }
  },
  computed: {
    activeHour () {
      if (!this.activeData.endHour && this.activeData.endHour !== 0) return [this.activeData.startHour, this.activeData.startHour]
      if (this.activeData.endHour < this.activeData.startHour) return [this.activeData.endHour, this.activeData.startHour]
      return [this.activeData.startHour, this.activeData.endHour]
    }
  },
  mounted () {
    this.formatTimeRangeToBlock()
  },
  methods: {
    handleCellMouseDown (event) {
      if (this.disabled) return
      this.mouseDown = true
      // reset activeData
      this.activeData = {
        day: null,
        startHour: null,
        endHour: null
      }
      const hour = Math.floor((event.layerX - 90) / this.BOX_SIZE.WIDTH) // 減去星期O的寬度90
      const day = Math.floor(event.layerY / this.BOX_SIZE.HEIGHT)
      if (day < 0 || day > 6 || hour < 0 || hour > 23) return
      this.activeData.day = day
      this.activeData.startHour = hour
    },
    handleCellMouseMove (event) {
      if (this.disabled) return
      if (!this.mouseDown) return
      const hour = Math.floor((event.layerX - 90) / this.BOX_SIZE.WIDTH) // 減去星期O的寬度90
      if (hour > 23) return
      this.activeData.endHour = hour
    },
    handleCellMouseUp () {
      if (this.disabled) return
      if (!this.mouseDown) return

      let smallerHour = this.activeData.startHour
      if (!this.activeData.endHour && this.activeData.endHour !== 0) this.activeData.endHour = this.activeData.startHour
      let biggerHour = this.activeData.endHour
      if (this.activeData.startHour > this.activeData.endHour) {
        smallerHour = this.activeData.endHour
        biggerHour = this.activeData.startHour
      }

      let mode = 'disabled' // disabled
      const tempArrayAdd = [...this.selectedTime[this.activeData.day]]
      const tempArrayDisabled = [...this.selectedTime[this.activeData.day]]
      for (let i = smallerHour; i <= biggerHour; i++) {
        if (!this.selectedTime[this.activeData.day][i]) {
          // 如果經過的路線都是已經勾選的，視為取消勾選（邏輯同公設預約的時段選擇）
          //= > 如果中間有原本未選取的格子，視為勾選
          mode = 'add'
        }
        tempArrayAdd[i] = 1
        tempArrayDisabled[i] = 0
      }
      if (mode === 'add') {
        this.selectedTime[this.activeData.day] = tempArrayAdd
      } else {
        this.selectedTime[this.activeData.day] = tempArrayDisabled
      }
      this.mouseDown = false
    },
    handleClickAllDay (dayIndex) {
      if (this.disabled) return
      this.$set(this.selectedTime, dayIndex, this.ALL_DAY)
    },
    handleClickSave () {
      const formattedTime = this.formatTimeBlockToRange()
      this.$emit('clickTimeRangeSave', formattedTime)
    },
    handleClickClearAll () {
      this.$confirm('確定要清除所有已選的時段嗎？', '', {
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      }).then(() => {
        for (let i = 0; i < this.selectedTime.length; i++) {
          this.$set(this.selectedTime, i, this.CLEAR_ALL_DAY)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    formatTimeBlockToRange () { // 將格子格式化成星期+時段 {Sunday: [[1, 3], [6, 8]], Monday ...}
      const formattedWeekActive = {} // 有選定(active)的格子，會有星期英文當key的格式
      const formattedWeekInactive = {} // 未選定的格子

      this.selectedTime.forEach((day, index) => {
        const formattedActiveDay = [] // 格式為：[[1, 3], [6, 8]]
        const formattedInactiveDay = []
        let startHour
        let endHour

        let pointValue // 紀錄現在正在計算的是 active(1=true) 還是 inactive(0=false)
        let i = 0
        // 迴圈遍歷整份格子，計算&格式化成連續 active/inactive 的時段
        while (i < day.length) {
          pointValue = day[i]
          if (day[i] === pointValue) {
            startHour = i

            let j = i
            while (j < day.length) {
              if (day[j + 1] === pointValue) {
                j++
              } else {
                break
              }
            }
            endHour = j
            if (pointValue) formattedActiveDay.push([startHour, endHour + 1]) // 顯示的時數，結束小時要+1，符合人對結束時間的定義
            else formattedInactiveDay.push([startHour, endHour + 1])

            if (i === j) i++
            else i = j + 1
          } else {
            i++
          }
        }
        const datKey = this.WEEKDAY.find(day => day.dayIndex === index).name
        formattedWeekActive[datKey] = formattedActiveDay
        formattedWeekInactive[datKey] = formattedInactiveDay
      })
      return ({
        formattedWeekActive,
        formattedWeekInactive
      })
    },
    formatTimeRangeToBlock () {
      const timeData = { ...this.timeData }
      this.WEEKDAY.forEach(day => {
        const dayDataTemp = [...this.CLEAR_ALL_DAY]
        if (timeData?.[day.name]?.length) {
          // [[1, 3], [5, 8]]
          timeData[day.name].forEach(time => {
            // [1, 3]
            for (let i = time[0]; i <= time[1] - 1; i++) { // 結束小時-1 才算當下的格子 ([1, 3] -> 01:00~03:00 => 實際上是01、02兩個完整小時)
              dayDataTemp[i] = 1
            }
          })
        }
        this.$set(this.selectedTime, day.dayIndex, dayDataTemp)
      })
    },
    timeRange (start, end) {
      return `${start.toString().padStart(2, '0')}:00-${end.toString().padStart(2, '0')}:00`
    },
    close () {
      this.formatTimeRangeToBlock()
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.time-setting {
  overflow-x: scroll;
  width: fit-content;
  user-select: none;
  &.disabled {
    opacity: .4;
  }
  .action-top {
    text-align: left;
    ul {
      padding-inline-start: 20px;
    }
    ul {
      li {
        list-style: disc;
        line-height: 1.3pc;
        color: $subFontColor;
      }
    }
    .description {
      color: $mainColor;
      font-size: map-get($fontSize, large);
      margin-top: 32px;
      margin-bottom: 16px
    }
    .edit-btn {
      ::v-deep span {
        font-size: map-get($fontSize, large);
      }
    }
  }
  .column-1 {
    width: 90px;
    text-align: left;
    flex-shrink: 0;
    &.box {
      background-color: $bgGrayGreen;
    }
  }
  .column-3 {
    width: 90px;
    flex-shrink: 0;
  }
  .head {
    display: flex;
    .hour {
      display: flex;
      .hour-display {
        width: 40px;
        height: 24px;
      }
    }
    .table-item-title {
      color: $grayFontColor;
      width: 73px;
    }
  }
  >.content {
    position: relative; //滑鼠事件使用
    border: .5px solid $borderDark1;
    border-radius: 8px;
    width: fit-content;
    margin-bottom: 25px;
    .day {
      display: flex;
      .box {
        border: .5px solid $borderDark1;
        box-sizing: border-box;
      }
      &:first-child {
        .time-title { //左上圓弧
          border-radius: 8px 0 0 0;
        }
        .btn-allDay { //右上圓弧
          border-radius: 0 8px 0 0;
        }
      }
      &:last-child {
        .time-title { //左下圓弧
          border-radius: 0 0 0 8px;
        }
        .btn-allDay { //右下圓弧
          border-radius: 0 0 8px 0;
        }
      }

      .time-title {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .time-box-block {
        display: flex;
      }
      .time-box {
        border: .5px solid $borderDark1;
        box-sizing: border-box;
        width: 40px;
        height: 40px;
        &:hover {
          background-color: $bgDark4;
        }
        &.selected {
          background-color: #fcf3cc;
          &:hover {
            background-color: #B7F9BA;
          }
        }
        &.active {
          background-color: #B7F9BA;
        }
      }
      .btn-allDay {
        display: flex;
        align-items: center;
        justify-content: center;
        .el-button {
          padding: 5px 12px;
        }
      }
    }
  }
  .action {
    padding-bottom: 25px;
    .el-button {
      width: 110px;
      padding-block: 12px;
    }
  }

  .time-range-display {
    display: flex;
    width: 1140px;
    border: 1px solid $borderDark1;
    border-radius: 8px;
    .day {
      flex: 1;
      .title {
        background-color: $bgGrayGreen;
        border-bottom: 1px solid $borderDark1;
      }
      .content {
        padding: 8px;
        .time-range {
          padding: 4px 0;
        }
      }
      >div {
        min-height: 50px;
        padding: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      &:not(:last-child) {
        border-right: 1px solid $borderDark1;
      }
      &:first-child {
        .title {
          border-radius: 8px 0 0 0;
        }
      }
      &:last-child {
        .title {
          border-radius: 0 8px 0 0;
        }
      }
    }
  }
}
</style>
